<template>
    <div>

        <el-form label-position="top">

            <el-tabs type="border-card" v-model="tabAtivo">
                <el-tab-pane label="FILTROS" name="filtros">

                        <el-row :gutter="10">
                            <el-col :xs="24" :sm="12" :md="12">
                                <el-form-item label="Instituição" key="instituicao" v-if="([4, 5, 6, 7].includes(Number($store.state.user.tipo)))">
                                    <el-select ref="instituicao_id" v-model="filtro.instituicao_id" filterable placeholder="Todas as Instituições" clearable>
                                        <el-option v-for="(item, i) in $store.state.instituicoes" :key="i" :label="item.nome" :value="item.id"> </el-option>
                                    </el-select>
                                </el-form-item>
                                <div class="style-form" v-if="[0, 1, 3, 9, 12].includes(Number(this.$store.state.user.tipo))">
                                    <label>Instituição</label>
                                    <div class="style-input readonly">{{ $store.state.config.instituicao.nome }}</div>
                                </div>
                            </el-col>
                            <el-col :xs="24" :sm="6" :md="6">
                                <el-form-item label="Data Inicial" key="data_inicial">
                                    <el-date-picker
                                        v-model="filtro.data_inicial"
                                        type="date"
                                        placeholder="Selecione"
                                        format="dd/MM/yyyy"
                                        value-format="yyyy-MM-dd">
                                    </el-date-picker>
                                </el-form-item>
                            </el-col>
                            <el-col :xs="24" :sm="6" :md="6">
                                <el-form-item label="Data Final" key="data_final">
                                    <el-date-picker
                                        v-model="filtro.data_final"
                                        type="date"
                                        placeholder="Selecione"
                                        format="dd/MM/yyyy"
                                        value-format="yyyy-MM-dd">
                                    </el-date-picker>
                                </el-form-item>
                            </el-col>
                        </el-row>

                </el-tab-pane>
            </el-tabs>

            <div class="u-mt-10">
                <el-row>
                    <el-col :xs="24" :sm="24" :md="24" class="u-text-right">
                        <el-button @click="gerarRelatorio('excel')" :loading="loadingButtonExcel" type="primary">EXCEL</el-button>
                        <el-button @click="gerarRelatorio('pdf')" :loading="loadingButtonPdf" type="primary">PDF</el-button>
                        <el-button @click="gerarRelatorio('html')" :loading="loadingButtonHtml" type="primary">HTML</el-button>
                    </el-col>
                </el-row>
            </div>

        </el-form>

    </div>
</template>
<script>
import cPanel from '../../../shared/c-panel/c-panel.vue';

export default {
    components: { cPanel },
    props: ['tipoPendencia'],
    data: () => ({
        tabAtivo: 'filtros',
        loadingButtonExcel: false,
        loadingButtonPdf: false,
        loadingButtonHtml: false,
        filtro: {
            instituicao_id: '',
            data_inicial: '',
            data_final: '',
        }
    }),
    mounted () {

        if([0, 1, 3, 9, 12].includes(Number(this.$store.state.user.tipo))){

            this.filtro.instituicao_id = this.$store.state.config.instituicao.id;
        }
    },
    methods: {

        gerarRelatorio(tipo){

            if(!this.filtro.data_inicial || !this.filtro.data_final){
                window.eventBus.$emit('alert', {msg: 'Informe a Data Inicial e a Data Final.', type: 'warning'});
                return false;
            }

            if(this.filtro.data_inicial > this.filtro.data_final){
                window.eventBus.$emit('alert', {msg: 'A Data Inicial não pode ser maior que a Data Final.', type: 'warning'});
                return false;
            }

            if(tipo == 'pdf') this.loadingButtonPdf = true;
            if(tipo == 'excel') this.loadingButtonExcel = true;
            if(tipo == 'html') this.loadingButtonHtml = true;

            this.filtro.tipo_pendencia = this.tipoPendencia;

            let instValor = 'Todas as Instituições';
            if ([0, 1, 3, 9, 12].includes(Number(this.$store.state.user.tipo))) {
                instValor = this.$store.state.config.instituicao.nome;
            } else if (this.filtro.instituicao_id && this.$refs.instituicao_id) {
                instValor = this.$refs.instituicao_id.selected.label;
            }

            let param = {
                filtros: this.filtro,
                ref: [
                    {nome: 'Instituição', valor: instValor},
                    {nome: 'Período', valor: this.$moment(this.filtro.data_inicial).format('DD/MM/YYYY') + ' a ' + this.$moment(this.filtro.data_final).format('DD/MM/YYYY')},
                    {nome: 'Tipo de Lançamento Pendente', valor: this.tipoPendencia == 1 ? 'Frequência' : 'Conteúdo'}
                ]
            };

            if (tipo === 'pdf') {

                let url = `/api/pdf/renderRelatorioPendencias/pdf`;
                window.eventBus.$emit('print', { url, param });
                this.loadingButtonPdf = false;

            } else if (tipo === 'excel') {

                this.$axios.post(`${this.$store.state.config.baseUrlApi}/api/pdf/renderRelatorioPendencias/excel`, { param }, this.$store.getters.getHeaderAuthExcel).then(response => {
                    const url = window.URL.createObjectURL(new Blob([response.data]));
                    const link = document.createElement('a');
                    link.href = url;
                    link.setAttribute('download', 'relatorio_pendencias.xlsx');
                    document.body.appendChild(link);
                    link.click();
                    this.loadingButtonExcel = false;
                }).catch((error) => {
                    this.loadingButtonExcel = false;
                    this.$store.commit('throwException', error);
                });

            } else if (tipo === 'html') {

                this.$axios.post(`${this.$store.state.config.baseUrlApi}/api/relatorio/generateCodAutorizacaoPrintHtml/renderRelatorioPendencias`, param, this.$store.getters.getHeaderAuth).then(response => {
                    this.loadingButtonHtml = false;
                    window.open(this.$store.state.config.baseUrlApi + "/api/relatorio/open/" + response.data.token, "_blank");
                }).catch((error) => {
                    this.loadingButtonHtml = false;
                    this.$store.commit('throwException', error);
                });

            }

        },

    }
}
</script>
